import axios from 'axios';

import { WORKFLOW_API_URL, WORKFLOW_APP_URL } from '@/env';
import http from '@/utils/http';

import { getApEmbedTokenUrl } from './apiUrls';
import { storeApEmbedToken } from './session';
import { ApAuthenticationResponse, ApEmbedHideFlags, ApEmbedTokenResponse } from './types';

export function getApEmbedToken(): Promise<ApEmbedTokenResponse> {
  return http.post(getApEmbedTokenUrl(), {}, { skipSuccessToast: true });
}

export async function exchangeApEmbedToken(jwt: string): Promise<ApAuthenticationResponse> {
  const response = await axios.post<ApAuthenticationResponse>(
    `${WORKFLOW_API_URL}/api/v1/kickcall/external-token`,
    { jwt },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return response.data;
}

export function buildApEmbedIframeUrl(
  session: ApAuthenticationResponse,
  hideFlags: ApEmbedHideFlags = {},
  initialRoute?: string
): string {
  const params = new URLSearchParams();
  params.set('response', JSON.stringify(session));
  if (initialRoute) params.set('initialRoute', initialRoute);
  Object.entries(hideFlags).forEach(([key, value]) => {
    if (value) params.set(key, '1');
  });
  return `${WORKFLOW_APP_URL}/kickcall/embed-lite?${params.toString()}`;
}

export async function loadApEmbedSession(hideFlags: ApEmbedHideFlags = {}, initialRoute?: string): Promise<string> {
  const { jwt } = await getApEmbedToken();
  const session = await exchangeApEmbedToken(jwt);
  storeApEmbedToken(session.token);
  return buildApEmbedIframeUrl(session, hideFlags, initialRoute);
}
